import * as Application from 'expo-application'
import * as React from 'react'

import { Config, useConfig } from '../../context/config'
import { ForceUpdateAppScreen } from '../../screens/ForceUpdateApp/ForceUpdateAppScreen'
import { isiOS, isNative } from '../../util/platform'

// Must be a child of the LocalesProvider in App.tsx to ensure that the
// translations are shown in the right language.
export function ForceUpdateApp({ children }: { children: JSX.Element }): JSX.Element {
  const { config } = useConfig()

  if (shouldForceUpdateApp(config)) {
    return (
      <ForceUpdateAppScreen
        partnerLogo={config.partnerLogo}
        partnerName={config.partnerName}
        appStoreItmsAppsUrl={config.partnerConfig.appStoreItmsAppsUrl}
      />
    )
  }

  return children
}

function shouldForceUpdateApp(config: Config): boolean {
  if (isNative() && Application.nativeApplicationVersion) {
    // We only check iOS for now, since Android has a system to do this in Google Play (see CAR-3333)
    if (
      isiOS() &&
      config.minimumSupportedAppVersion.ios &&
      Application.nativeApplicationVersion < config.minimumSupportedAppVersion.ios
    ) {
      return true
    }
  }
  return false
}
